import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Box, Diagram} from "../shared/Diagram"

export default function MultiTenancyModels() {
    return (
        <TopicLayout
            title="Multi-tenancy models"
            intro="How tenant data is isolated in a shared system: one shared table with a tenant column, one schema per tenant inside a shared database, or a fully separate database per tenant."
            diagram={
                <Diagram viewBox="0 0 560 170">
                    <text x={95} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Shared table</text>
                    <Box x={35} y={65} width={120} height={50} label="orders" sublabel="+ tenant_id column" accent/>
                    <text x={95} y={150} textAnchor="middle" fontSize={11} opacity={0.7}>cheap, noisy-neighbor risk</text>

                    <line x1={185} y1={10} x2={185} y2={160} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={278} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Schema-per-tenant</text>
                    <rect x={210} y={50} width={140} height={80} rx={6}
                          style={{fill: 'none', stroke: 'var(--header-background)', strokeWidth: 1.5, strokeDasharray: '5 4'}}/>
                    <Box x={225} y={65} width={110} height={26} label="Tenant A schema"/>
                    <Box x={225} y={98} width={110} height={26} label="Tenant B schema"/>
                    <text x={278} y={150} textAnchor="middle" fontSize={11} opacity={0.7}>isolated, one DB to operate</text>

                    <line x1={375} y1={10} x2={375} y2={160} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={465} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>DB-per-tenant</text>
                    <Box x={390} y={75} width={75} height={40} label="Tenant A" sublabel="DB" accent/>
                    <Box x={475} y={75} width={75} height={40} label="Tenant B" sublabel="DB" accent/>
                    <text x={465} y={150} textAnchor="middle" fontSize={11} opacity={0.7}>strongest isolation, most overhead</text>
                </Diagram>
            }
            useWhen={[
                'Shared table: many small tenants, cost efficiency matters most, and per-tenant isolation requirements are modest.',
                'Schema-per-tenant: tenants need stronger data isolation or per-tenant customization, but running hundreds of separate database instances is not practical.',
                'DB-per-tenant: tenants have strict compliance, performance-isolation or data-residency requirements that justify the operational cost.'
            ]}
            tradeOff="A shared table is the cheapest to run and scales to the most tenants, but every query must filter by tenant_id correctly — a missing filter is a data leak, not just a bug — and one noisy tenant can degrade everyone sharing the table. Schema- or database-per-tenant isolates that blast radius and makes per-tenant backup, restore and compliance boundaries clean, at the cost of migrations, monitoring and capacity planning that now multiply by tenant count. Retrofitting stronger isolation after launching with a shared table is a significant migration, so this decision is worth making deliberately up front."
            ruleOfThumb="Start with a shared table plus a mandatory, enforced tenant_id filter (row-level security if the database supports it) unless a specific compliance or scale requirement demands stronger isolation from day one."
        />
    )
}
